import React, { useMemo } from 'react'

import { Route } from 'react-router-dom'

// import Level2ValidationAntd from './Level2ValidationAntd'
// import Level2ValidationErrorLogAntd from './Level2ValErrorAntd'
import Level2ValStatusAntd from './Level2ValStatusAntd'
import Level2ValidationTab from './TabValidationScreen'
import ValidationMonthly from './ValidationMonthly'
import BlockLevelValidation from './BlockLevel2Validation'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import PjmLevel2ValStatus from './PjmLevel2ValStatusAntd'
import { BROOKFIELD_CLIENT, PJM_CLIENT } from 'client'

const GadsValidationContainer = ({ actionPermits, envConfig }) => {
  const CLIENT = envConfig.clientId || 'INTEG'

  const hasValidation = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [
      ScreenPermissions.VALIDATION_RUNCHECK,
      ScreenPermissions.VALIDATION_LOG,
      ScreenPermissions.VALIDATION_BLOCK_LEVEL_2_PROCESSING,
      ScreenPermissions.VALIDATION_MONTHLY,
    ],
    matchAny: true,
  })

  const hasBlockLevel2 = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.VALIDATION_BLOCK_LEVEL_2_PROCESSING],
    matchAny: true,
  })

  const hasValidationMonthly = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.VALIDATION_MONTHLY],
    matchAny: true,
  })

  const ValidationStatus = useMemo(
    _ =>
      CLIENT === PJM_CLIENT || CLIENT === BROOKFIELD_CLIENT
        ? PjmLevel2ValStatus
        : Level2ValStatusAntd,
    [CLIENT]
  )

  return (
    <React.Fragment>
      {hasValidation && (
        <Route
          te
          key="validation-status"
          exact
          path="/level-2-validation-status-antd"
          component={ValidationStatus}
        />
      )}
      {hasValidation && (
        <Route
          key="level2-validation"
          exact
          path="/level-2-validation-tab"
          component={Level2ValidationTab}
        />
      )}
      {hasValidationMonthly && (
        <Route
          key="validation-monthly"
          exact
          path="/validation-monthly"
          component={ValidationMonthly}
        />
      )}
      {hasBlockLevel2 && (
        <Route
          key="validation-block-level-2"
          exact
          path="/validation-block-level-2"
          component={BlockLevelValidation}
        />
      )}
    </React.Fragment>
  )
}
export default GadsValidationContainer
